import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {UploadSellerIdRequestTransactionsValueObject} from '../ValueObjects/UploadSellerIdRequestTransactionsValueObject.js'

/**
 * @implements UseCase
 */
export class UploadSellerIdTransactionsUseCase extends UseCase {
  constructor({httpTransactionsRepository}) {
    super()
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  @inlineError
  async execute({documentBack, documentFront, tradeId}) {
    const uploadSellerIdRequestTransactionsValueObject = UploadSellerIdRequestTransactionsValueObject.create({
      documentBack,
      documentFront,
      tradeId
    })

    const [error] = await this._httpTransactionsRepository.uploadSellerId(uploadSellerIdRequestTransactionsValueObject)

    if (error) return Promise.reject(error)
  }
}
